import React from "react";

export default function InventoryBalanceTable({ rows = [], onViewLedger }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
      <div className="overflow-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="text-left px-4 py-3">Resource</th>
              <th className="text-left px-4 py-3">Warehouse</th>
              <th className="text-left px-4 py-3">Location</th>
              <th className="text-right px-4 py-3">Qty On Hand</th>
              <th className="text-right px-4 py-3">Avg Unit Cost</th>
              <th className="text-right px-4 py-3">Amount On Hand</th>
              <th className="text-right px-4 py-3">Min Stock</th>
              <th className="text-right px-4 py-3">Reorder Qty</th>
              <th className="text-left px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((row) => (
                <tr
  key={row.id}
  className={`border-t ${Number(row.is_low_stock) ? "bg-red-50" : ""}`}
>
                  <td className="px-4 py-3">
                    {row.resource_name || row.resource_item_name || row.resource_item_id}
                  </td>
                  <td className="px-4 py-3">
                    {row.warehouse_name || row.warehouse_id}
                  </td>
                  <td className="px-4 py-3">
                    {row.location_name || row.location_id}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.qty_on_hand || 0).toFixed(4)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.avg_unit_cost || 0).toFixed(4)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.amount_on_hand || 0).toFixed(4)}
                  </td>
                  <td className="px-4 py-3 text-right">
  {Number(row.min_stock_qty || 0).toFixed(4)}
</td>
<td className="px-4 py-3 text-right">
  {Number(row.reorder_qty || 0).toFixed(4)}
</td>
                  <td className="px-4 py-3">
                    <button
                      type="button"
                      onClick={() => onViewLedger?.(row)}
                      className="px-3 py-1.5 rounded-lg border"
                    >
                      View Ledger
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="px-4 py-6 text-center text-slate-500">
                  No inventory balances found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}